import { Typography } from '@mui/material';

const Loading = () => (
    <Typography variant="overline" display="block" align="center">
        LOADING...
    </Typography>
);

export default Loading;
